import $ from 'jquery';
require('responsive-carousel/src/responsive-carousel.js');

$(function() {
    $('.carousel').carousel();
});


const openFullScreen = function(el) {
    el.classList.add('publication_component-fullscreen');
};
const closeFullScreen = function(el) {
    el.classList.remove('publication_component-fullscreen');
};

$(document).on('click', '.publication_component-fullscreen > .cover', function(e) {
    e.preventDefault();
    closeFullScreen(e.currentTarget.parentElement);
});
$(document).on('click', '.publication_component > .expand', function(e) {
    e.preventDefault();
    e.stopPropagation();
    openFullScreen(e.currentTarget.parentElement);
});
$(document).keyup(function(e) {
    if (e.keyCode === 27) {
        const el = document.querySelector('.publication_component-fullscreen');
        if (el) {
            closeFullScreen(el);
        }
    }
});



// WEBPACK FOOTER //
// ./scripts/publication.js